import { createFileRoute } from "@tanstack/react-router";
import { CelebrityResultPage } from "@/components/site/CelebrityResultPage";
import { bryanBickell } from "@/lib/celebrity-results/bryan-bickell";
import { absoluteUrl } from "@/lib/absolute-url";

const TITLE = "Bryan Bickell Hair Transplant Results | RESTORE® Hair";
const DESC = "See former NHL player Bryan Bickell's RESTORE® No-Shave FUE™ hair transplant results, before & after photos and his full hair restoration story.";
const POSTER = "/img/r/wp-2024-09-bryan-bickell-img-1.webp";

export const Route = createFileRoute("/results/bryan-bickell")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:type", content: "article" },
      { property: "og:url", content: "https://restorehair.com/results/bryan-bickell/" },
      { property: "og:image", content: absoluteUrl(POSTER) },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:image", content: absoluteUrl(POSTER) },
    ],
    links: [
      { rel: "canonical", href: "https://restorehair.com/results/bryan-bickell/" },
    ],
  }),
  component: () => <CelebrityResultPage data={bryanBickell} />,
});
